import echarts from 'echarts';
// 雄安-无痕折线图
export const noLineChart = () => {
    return {
        series: [
            {
                type: "line",
                name: "ddd",
                symbolSize: 4,
                lineStyle: {
                    color: "#038CFB",
                    width: 3
                },
                itemStyle: {
                    opacity: 0
                },
                smooth: 0.2,
                data: []
            }
        ],
        grid: {
            top: 6,
            left: 2,
            right: 2,
            bottom: 20
        },
        xAxis: {
            type: "category",
            boundaryGap: false,
            axisPointer: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLabel: {
                show: false
            },
            axisLine: {
                show: false
            },
            //刻度
            axisTick: {
                show: true,
                interval: 0,
                length: 4,
                lineStyle: {
                    color: 'rgba(255,255,255,0.40)'
                }
            },
            data: ['10.28', '10.29', '10.30', '10.31', '11.1', '11.2', '11.3']
        },
        yAxis: {
            boundaryGap: ["0", "23%"],
            //轴线
            axisLine: {
                show: false
            },
            min: function(value) {
                return value.min;
            },
            max: function(value) {
                return value.max;
            },
            //刻度
            axisTick: {
                show: false
            },
            //切割线
            splitLine: {
                show: false
            },
            axisLabel: {
                show: false
            }
        }
    }
};
// 雄安-流量折线图
export const lineCommon = () => {
    return {
        series: [
            {
                type: "line",
                symbolSize: 3,
                lineStyle: {
                    color: "#038CFB",
                    width: 2
                },
                itemStyle: {
                    color: "#8ec6ad",
                    borderWidth: 6,
                    borderColor: "#038CFB"
                },
                areaStyle: {
                    normal: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: "rgba(3,140,251,0.45)"
                            },
                            {
                                offset: 1,
                                color: "rgba(3,140,251,0.03)"
                            }
                        ])
                    }
                },
                data: []
            }
        ],
        grid: {
            top: 10,
            left: 50,
            right: 40,
            bottom: 50
        },
        xAxis: {
            type: "category",
            boundaryGap: false,
            axisPointer: {
                show: false,
                value: '00:00',
                gridIndex: 0,
                status: 'show',
                label: {
                    show: false
                },
                lineStyle: {
                    width: 6,
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: "#038CFB"
                        },
                        {
                            offset: 1,
                            color: "#24F2D8"
                        }
                    ])
                }
            },
            splitLine: {
                show: false
            },
            axisLabel: {
                margin: '18',
                color: '#fff',
                fontFamily: 'AgencyFB-Reg',
                lineHeight: 22,
                fontSize: 12,
            },
            axisLine: {
                lineStyle: {
                    color: 'rgba(0,177,255,0.35)',
                    width: 2
                }
            },
            //刻度
            axisTick: {
                show: false
            },
            data: []
        },
        yAxis: {
            boundaryGap: ["0", "23%"],
            splitNumber: 3,
            //轴线
            axisLine: {
                show: false
            },
            //刻度
            axisTick: {
                show: false
            },
            //切割线
            splitLine: {
                show: true,
                lineStyle: {
                    color: "rgba(255,255,255,0.10)",
                    width: 2
                }
            },
            axisLabel: {
                margin: '10',
                color: '#fff',
                fontFamily: 'AgencyFB-Reg',
                lineHeight: 22,
                fontSize: 12
            }
        }
    };
}
// 雄安-柱状图
export const hotCityBar = (d) => {
    let data = d;
    let valueArr = [];
    const xAxisData = data.map(item => {
        valueArr.push(item.value);
        return item.name;
    });
    const max = Math.floor((Math.max(...valueArr)) / 0.85);
    const total = data.length && data.reduce((acc, cur) => {
        const tempAcc = typeof acc === 'object' ? acc.value : acc;
        return Number(tempAcc) + Number(cur.value);
    });
    return {
        series: [
            {
                type: "bar",
                name: "ddd",
                label: {
                    normal: {
                        show: true,
                        fontSize: 12,
                        fontWeight: "bold",
                        position: "top",
                        color: "#00CFFF",
                        padding: [4, 2],
                        formatter: (param) => {
                            return `${(param.value*100/total).toFixed(0)}%`
                        }
                    }
                },
                barWidth: 16,
                itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: "#038CFB"
                        },
                        {
                            offset: 1,
                            color: "#102FA8"
                        }
                    ])
                },
                data: data.map((item, index) => {
                    if (index == 0) {
                        return {
                            ...item,
                            itemStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(
                                        0,
                                        1,
                                        0,
                                        0,
                                        [
                                            {
                                                offset: 0,
                                                color: "#102FA8" // 0% 处的颜色
                                            },
                                            {
                                                offset: 1,
                                                color: "#24F2D8" // 100% 处的颜色
                                            }
                                        ],
                                        false
                                    )
                                }
                            }
                        };
                    } else {
                        return { ...item };
                    }
                })
            }
        ],
        grid: {
            top: 20,
            left: 50,
            right: 10,
            bottom: 22
        },
        xAxis: {
            type: "category",
            boundaryGap: true,
            axisLabel: {
                margin: 6,
                fontSize: 12,
                fontFamily: "PingFangSC-Medium",
                color: "rgba(255,255,255,.75)",
                lineHeight: 22
            },
            axisLine: {
                show: false
            },
            //刻度
            axisTick: {
                show: false
            },
            data: xAxisData
        },
        yAxis: {
            max: max,
            splitNumber: 3,
            //轴线
            axisLine: {
                show: false
            },
            //刻度
            axisTick: {
                show: false
            },
            //切割线
            splitLine: {
                show: false,
                lineStyle: {
                    color: "rgba(255,255,255,0.10)",
                    width: 1
                }
            },
            axisLabel: {
                fontSize: 12,
                fontFamily: "AgencyFB-Reg",
                color: "rgba(255,255,255,0.75)",
                lineHeight: 20
            }
        }
    }
};
// 雄安-散点图
export const activeScatter = () => {
    return {
        xAxis: {
            axisLine: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLabel: {
                show: false
            },
            axisTick: {
                show: false
            }
        },
        yAxis: {
            axisLine: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLabel: {
                show: false
            },
            axisTick: {
                show: false
            }
        },
        series: [{
            symbolSize: 10,
            itemStyle: {
                color: '#FF8700',
                shadowColor: '#fff',
                shadowBlur: 10
            },
            data: [
                [8.0, 6.95],
                [13.0, 7.58],
                [9.0, 8.81],
                [11.0, 8.33],
                [14.0, 9.96],
                [6.0, 7.24],
                [4.0, 4.26],
                [12.0, 10.84],
                [7.0, 4.82],
                [2.0, 5.68],
                [1.0, 2.68],
                [3.0, 4.68],
            ],
            type: 'scatter'
        }]
    };
};
// 相关性气泡图
export const relationScatter = (data, xName, yName) => {
    return {
        grid: {
            top: 50,
            left: 40,
            right: 60,
            bottom: 40
        },
        legend: {
            right: 10,
            data: ['1990', '2015'],
            textStyle: {
                color: '#fff'
            }
        },
        xAxis: {
            name: xName || 'GDP',
            axisLine: {
                lineStyle: {
                    color: "rgba(255,255,255,0.75)",
                }
            },
            splitLine: {
                show: false
            }
        },
        yAxis: {
            name: yName || '年龄',
            axisLine: {
                lineStyle: {
                    color: "rgba(255,255,255,0.75)",
                }
            },
            splitLine: {
                show: false
            },
            scale: true
        },
        series: [{
            name: '1990',
            data: data[0],
            type: 'scatter',
            symbolSize: function (data) {
                return Math.sqrt(data[2]) / 5e2;
            },
            emphasis: {
                label: {
                    color: '#fff',
                    show: true,
                    formatter: function (param) {
                        return param.data[3];
                    },
                    position: 'top'
                }
            },
            itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(120, 36, 50, 0.5)',
                shadowOffsetY: 5,
                color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [{
                    offset: 0,
                    color: 'rgb(251, 118, 123)'
                }, {
                    offset: 1,
                    color: 'rgb(204, 46, 72)'
                }])
            }
        }, {
            name: '2015',
            data: data[1],
            type: 'scatter',
            symbolSize: function (data) {
                return Math.sqrt(data[2]) / 5e2;
            },
            emphasis: {
                label: {
                    color: '#fff',
                    show: true,
                    formatter: function (param) {
                        return param.data[3];
                    },
                    position: 'top'
                }
            },
            itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(25, 100, 150, 0.5)',
                shadowOffsetY: 5,
                color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [{
                    offset: 0,
                    color: 'rgb(129, 227, 238)'
                }, {
                    offset: 1,
                    color: 'rgb(25, 183, 207)'
                }])
            }
        }]
    };
};
// 雷达图
export const radar = (series,items,legend) => {
    return {
        legend: {
            itemGap: 30,
            textStyle: {  
                color: '#fff'
            },
            data: legend
        },
        color: ['rgba(0,210,179,1)', 'rgba(251,169,0,1)', 'rgba(242,112,54,1)', 'rgba(181,40,81,1)'],
        radar: {
            name: {
                textStyle: {
                    color: '#fff',
                    backgroundColor: '#000',
                    borderRadius: 3,
                    padding: [2, 5]
                }
            },
            indicator: items,
            axisLine: {
                lineStyle: {
                    color: '#333'
                }
            },
            splitArea: {
                areaStyle: {
                    color: ['#000']
                }
            },
            splitLine: {
                lineStyle: {
                    color: 'grey',
                    opacity: 0.6
                }
            }
        },
        series: series
    };
};
// 仪表盘
export const gauge = (title, value, unit) => {
    return {
        tooltip: {
            formatter: '{a} <br/>{c} {b}'
        },
        series: [
            {
                name: title,
                type: 'gauge',
                min: 0,
                max: 220,
                splitNumber: 11,
                radius: '90%',
                axisLine: {            // 坐标轴线
                    lineStyle: {       // 属性lineStyle控制线条样式
                        color: [[0.09, 'lime'], [0.82, '#1e90ff'], [1, '#ff4500']],
                        width: 3,
                        // shadowColor: '#fff', //默认透明
                        // shadowBlur: 10
                    }
                },
                axisLabel: {            // 坐标轴小标记
                    fontWeight: 'bolder',
                    color: '#fff',
                    // shadowColor: '#fff', //默认透明
                    // shadowBlur: 10
                },
                axisTick: {            // 坐标轴小标记
                    length: 15,        // 属性length控制线长
                    lineStyle: {       // 属性lineStyle控制线条样式
                        color: 'auto',
                        // shadowColor: '#fff', //默认透明
                        // shadowBlur: 10
                    }
                },
                splitLine: {           // 分隔线
                    length: 25,         // 属性length控制线长
                    lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                        width: 3,
                        color: '#fff',
                        // shadowColor: '#fff', //默认透明
                        // shadowBlur: 10
                    }
                },
                pointer: {           // 分隔线
                    shadowColor: '#fff', //默认透明
                    shadowBlur: 5
                },
                title: {
                    textStyle: {       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                        fontWeight: 'bolder',
                        fontSize: 20,
                        fontStyle: 'italic',
                        color: '#fff',
                        shadowColor: '#fff', //默认透明
                        shadowBlur: 10
                    }
                },
                detail: {
                    backgroundColor: 'rgba(30,144,255,0.8)',
                    borderWidth: 1,
                    // borderColor: '#fff',
                    // shadowColor: '#fff', //默认透明
                    shadowBlur: 5,
                    offsetCenter: [0, '50%'],       // x, y，单位px
                    textStyle: {       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                        fontWeight: 'bolder',
                        color: '#fff'
                    }
                },
                data: [{value: value, name: unit}]
            }
        ]
    };
};
// 漏斗图
export const funnel = (data, legend) => {
    return {
        tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c}%"
        },
        legend: {
            itemGap: 30,
            textStyle: {  
                color: '#fff'
            },
            data: legend
        },
        series: [
            {
                name:'漏斗图',
                type:'funnel',
                left: '10%',
                top: 60,
                bottom: 60,
                width: '80%',
                min: 0,
                max: 100,
                minSize: '0%',
                maxSize: '100%',
                sort: 'descending',
                gap: 2,
                label: {
                    show: true,
                    position: 'inside'
                },
                labelLine: {
                    length: 10,
                    lineStyle: {
                        width: 1,
                        type: 'solid'
                    }
                },
                itemStyle: {
                    borderColor: '#fff',
                    borderWidth: 1
                },
                emphasis: {
                    label: {
                        fontSize: 20
                    }
                },
                data: data
            }
        ]
    };
};
// 锥形柱状图
export const coneBar = (data) => {
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'none'
            },
            formatter: function (params) {
                return params[0].name + ': ' + params[0].value;
            }
        },
        xAxis: {
            data: data.xData,
            axisTick: {show: false},
            axisLine: {show: false},
            axisLabel: {
                color: '#e54035'
            }
        },
        yAxis: {
            splitLine: {show: false},
            axisTick: {show: false},
            axisLine: {show: false},
            axisLabel: {show: false}
        },
        color: ['#e54035'],
        series: [{
            name: 'hill',
            type: 'pictorialBar',
            barCategoryGap: '-130%',
            symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
            itemStyle: {
                opacity: 0.7
            },
            emphasis: {
                itemStyle: {
                    opacity: 1
                }
            },
            data: data.singleData,
            z: 10
        }, {
            name: 'glyph',
            type: 'pictorialBar',
            barGap: '-100%',
            symbolPosition: 'end',
            symbolSize: 50,
            symbolOffset: [0, '-120%'],
            data: data.data
        }]
    };
};
// 个性柱线图
export const customBar = (data, legend) => {
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: function(value) {
                return `${value[0].name}<br>${legend[0]}: ${value[0].value}<br>${legend[1]}: ${value[1].value}`;
            }
        },
        legend: {
            data: legend,
            textStyle: {
                color: '#ccc'
            }
        },
        xAxis: {
            data: data.xData,
            axisLine: {
                lineStyle: {
                    color: '#ccc'
                }
            }
        },
        yAxis: {
            splitLine: {show: false},
            axisLine: {
                lineStyle: {
                    color: '#ccc'
                }
            }
        },
        series: [{
            name: legend[0],
            type: 'line',
            smooth: true,
            showAllSymbol: true,
            symbol: 'emptyCircle',
            symbolSize: 15,
            data: data.data.line
        }, {
            name: legend[1],
            type: 'bar',
            barWidth: 10,
            itemStyle: {
                barBorderRadius: 5,
                color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                        {offset: 0, color: 'rgba(45,140,240,1)'},
                        {offset: 1, color: 'rgba(0,210,179,1)'}
                    ]
                )
            },
            data: data.data.bar
        }, {
            name: legend[0],
            type: 'bar',
            barGap: '-100%',
            barWidth: 10,
            itemStyle: {
                color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                        {offset: 0, color: 'rgba(20,200,212,0.5)'},
                        {offset: 0.2, color: 'rgba(20,200,212,0.2)'},
                        {offset: 1, color: 'rgba(20,200,212,0)'}
                    ]
                )
            },
            z: -12,
            data: data.data.line
        }, {
            name: 'dotted',
            type: 'pictorialBar',
            symbol: 'rect',
            itemStyle: {
                color: '#0f375f'
            },
            symbolRepeat: true,
            symbolSize: [12, 4],
            symbolMargin: 1,
            z: -10,
            data: data.data.line
        }]
    };
};